module.exports = __webpack_public_path__ + "static/img/__7785.8669f05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__7785.jpg
// module id = 9+13
// module chunks = 0